const React = require('react');
require('./search-dish.scss');
const SearchHead = require('../mui/search-head.jsx');
const DishListItem = require('./dish-list-item.jsx');
const noSearchImg = require('../../asset/images/search-big.svg');
const IScroll = require('@portal/iscroll/build/iscroll-probe');
const helper = require('../../helper/dish-helper');
const { isFormalMeal } = require('../../helper/common-helper');
const shopId = helper.getUrlParam('shopId');
const isEqualWith = require('../../utils/isequalwith.js');

import FormattedMessage from '@/intl/formatted-message';
import { formatMessage } from '../../intl/helper';
import globalMessages from '../../intl/messages/global';
import buttonMessages from '../../intl/messages/button';
import buryingPoint, { getPageTypeFromUrl } from '../../helper/divolte/register-divolte';

const SearchDish = React.createClass({
  displayName: 'SearchDish',
  propTypes: {
    dishesData: React.PropTypes.array.isRequired,
    dishTypesData: React.PropTypes.array.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onPropsBtnTap: React.PropTypes.func.isRequired,
    onImageBtnTap: React.PropTypes.func.isRequired,
    marketList: React.PropTypes.object,
    diningForm: React.PropTypes.number,
    setSearchPage: React.PropTypes.func,
    scanShow: React.PropTypes.bool,
    isHDL: React.PropTypes.bool,
  },
  getInitialState() {
    return {
      keyWord: '',
      searchedDataFromLocalHistory: JSON.parse(localStorage.searchedDataFromLocalHistory || '{}'),
    };
  },
  componentWillMount() {
    this._cache = {};
    this.timer = null;
  },
  componentDidMount() {
    // this.setIscroll();
  },
  componentWillReceiveProps() {
    const { searchedDataFromLocalHistory } = this.state;
    const searchResult = JSON.parse(localStorage.searchedDataFromLocalHistory || '{}');
    if (!isEqualWith(searchedDataFromLocalHistory, searchResult)) {
      this.setState({ searchedDataFromLocalHistory: searchResult });
    }
  },
  componentDidUpdate(prevProps, prevState) {
    /*
    this.forceLazyLoadCheck();
    if (prevState.keyWord !== this.state.keyWord) { // keyWord 改变的时候重新启动Iscroll
      this.iScroll.destroy();
      // this._cache = null;
      setTimeout(() => {
        this.setIscroll();
      }, 300);
    }
    */
    if (prevState.keyWord !== this.state.keyWord) {
      // keyWord 改变的时候重新启动Iscroll
      document.querySelector('.search-content').scrollTop = 0;
    }
  },
  componentWillUnmount() {
    // this.iScroll.destroy();
    // this._cache = null;
    if (!!this.timer) clearTimeout(this.timer);
  },
  /**
   * 查询内容 埋点
   */
  buryingPointSearch(searchContent) {
    try {
      if (!!this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (searchContent !== '' || searchContent !== null || searchContent !== undefined) {
          const pageType = getPageTypeFromUrl();
          buryingPoint.send('SearchContent', { pageType, searchContent });
        }
      }, 800);
    } catch (ex) {
      console.error(ex);
    }
  },
  onDishBtnTap(dishData, action) {
    const { onOrderBtnTap, onPropsBtnTap } = this.props;
    this.blurInput();
    if (action) {
      onOrderBtnTap(dishData, action);
    } else {
      onPropsBtnTap(dishData);
    }
  },
  onImageBtnTap(dish) {
    this.blurInput();
    this.props.onImageBtnTap(dish);
  },
  setIscroll() {
    this._cache = {};
    const iScroll = (this.iScroll = new IScroll('.search-content', {
      click: true,
      tap: true,
      probeType: 3,
    }));

    iScroll.on('scrollStart', () => {
      this.blurInput();
    });

    iScroll.on('scroll', () => {
      this.forceLazyLoadCheck();
    });

    iScroll.on('scrollEnd', () => {
      this.forceLazyLoadCheck();
    });
  },
  getKeyWord(keyWord = '') {
    setTimeout(() => {
      this.setState({ keyWord });
      this.buryingPointSearch(keyWord);
    }, 300);
  },
  blurInput() {
    document.getElementsByClassName('search-input')[0].blur();
  },
  headButtonClickCallBack(evt) {
    evt.preventDefault();
    // 点击取消之后的操作
    const { setSearchPage } = this.props;
    setSearchPage(false);
  },
  readyToSearch(evt, name) {
    evt.preventDefault();
    this.setState({ keyWord: name });
    this.refs.searchhead.refs.keyword.value = name;
    this.refs.searchhead.changeKeyWord();
    this.buryingPointSearch(name);
  },
  clearSearchedFromLocalHistory() {
    const searchedDataFromLocalHistory = JSON.parse(localStorage.searchedDataFromLocalHistory);
    delete searchedDataFromLocalHistory[shopId];
    localStorage.searchedDataFromLocalHistory = JSON.stringify(searchedDataFromLocalHistory);
    this.setState({ searchedDataFromLocalHistory });
  },
  deleteToSearch(evt, name) {
    evt.preventDefault();
    evt.stopPropagation();
    const searchedDataFromLocalHistory = JSON.parse(localStorage.searchedDataFromLocalHistory);
    const sdArray = searchedDataFromLocalHistory[shopId].split(','); // 数组
    const position = sdArray.indexOf(name);
    const obj = {};

    delete sdArray[position];
    obj[shopId] = sdArray.filter(item => !!item).join(',');
    if (!obj[shopId]) {
      delete searchedDataFromLocalHistory[shopId];
    }

    const newObj = Object.assign({}, searchedDataFromLocalHistory, obj[shopId] ? obj : {});
    localStorage.searchedDataFromLocalHistory = JSON.stringify(newObj);
    this.setState({ searchedDataFromLocalHistory: newObj });
  },
  getSearchedFromLocalHistory() {
    const { diningForm } = this.props;
    const historyList = (JSON.parse(localStorage.searchedDataFromLocalHistory || '{}')[shopId] || '').split(',');
    if (historyList.filter(item => !!item).length === 0) {
      return;
    }

    return (
      <div className={`hot-search-outer o-flex o-flex--column ${isFormalMeal(diningForm) ? 'hot-search-outer-zc' : ''}`}>
        <div className="hot-search__delete o-flex__fluid">
          <div className="hot-search__title o-fz--13">
            <FormattedMessage {...globalMessages.historySearch} />
          </div>
          {(historyList || []).map((item, index) => (
            <p className="hot-search__delete__item o-flex o-fz--14" key={index} onTouchTap={e => this.readyToSearch(e, item)}>
              {item}
              <span className="hot-search__delete__icon" onTouchTap={e => this.deleteToSearch(e, item)}></span>
            </p>
          ))}
        </div>
        <div className="hot-search__deleteall o-flex__fixed o-fz--14" onTouchTap={this.clearSearchedFromLocalHistory}>
          <FormattedMessage {...globalMessages.clearSearch} />
        </div>
      </div>
    );
  },
  formatSearchDishItem(keyWord = '') {
    const { dishesData, dishTypesData, isHDL } = this.props;
    let filterDishes = [];
    const keyValue = keyWord.replace(/\s/g, '').toLocaleLowerCase();

    if (!keyValue) {
      return this.getSearchedFromLocalHistory();
    }

    // 完全匹配
    filterDishes = Array.prototype.slice.call(dishesData).filter(item => item.name.toLocaleLowerCase() === keyValue) || [];
    // 全匹配
    filterDishes = filterDishes.concat(
      dishesData.filter(item => {
        const nameLowerCase = item.name.toLocaleLowerCase();
        return nameLowerCase !== keyValue && nameLowerCase.indexOf(keyValue) !== -1;
      }),
    );
    // 合并空格匹配
    filterDishes = filterDishes.concat(
      dishesData.filter(item => {
        const nameLowerCase = item.name.toLocaleLowerCase();
        return nameLowerCase !== keyValue && nameLowerCase.indexOf(keyValue) === -1 && nameLowerCase.replace(/\s/g, '').indexOf(keyValue) !== -1;
      }),
    );
    // 模糊匹配
    filterDishes = filterDishes.concat(
      dishesData.filter(item => {
        const nameLowerCase = item.name.toLocaleLowerCase();
        const bool = nameLowerCase !== keyValue && nameLowerCase.indexOf(keyValue) === -1 && nameLowerCase.replace(/\s/g, '').indexOf(keyValue) === -1;
        let newBool = true;
        const newArray = keyValue.split('');
        newArray.forEach((itemt, indext) => {
          if (nameLowerCase.indexOf(itemt) === -1) {
            newBool = false;
          }
        });
        return bool && newBool;
      }),
    );

    // 对filterDishes建立索引
    const newfilterDishes = filterDishes.map((item, index) => item.set('sort', index));

    const totalDishArray = [];
    const arrayKeep = [];
    dishTypesData.forEach((dishTypeData, idx) => {
      (dishTypeData.dishIds || []).forEach((dishId, i) => {
        const dishData = newfilterDishes.filter(dish => dish.id === dishId)[0] || null;
        if (!dishData || dishData.proxyDishId) {
          return false;
        }
        if (arrayKeep.indexOf(dishId) !== -1) {
          return false;
        }
        arrayKeep.push(dishId);
        const { sameDishIndexs } = dishData;
        const sameRuleDishList = sameDishIndexs ? sameDishIndexs.map(dishIndex => dishesData[dishIndex]) : null;
        totalDishArray.push({
          sort: dishData.sort,
          obj: (
            <li className="dish-item-dish" key={dishData.sort}>
              <DishListItem
                theme="default"
                dishData={dishData}
                sameRuleDishList={sameRuleDishList}
                onOrderBtnTap={this.onDishBtnTap}
                onPropsBtnTap={this.onDishBtnTap}
                onImageBtnTap={this.onImageBtnTap}
                marketList={this.props.marketList}
                diningForm={this.props.diningForm}
                highLightName={keyWord.replace(/\s/g, '')}
                isHDL={isHDL}
                isFromSearch
              />
            </li>
          ),
        });
        return true;
      });
      return true;
    });
    return totalDishArray.sort((a, b) => a.sort - b.sort).map((item, index) => item.obj);
  },
  forceLazyLoadCheck() {
    const { lazyloadCheckTimer } = this._cache;
    if (lazyloadCheckTimer) {
      window.clearTimeout(lazyloadCheckTimer);
      this._cache.lazyloadCheckTimer = null;
    }
    this._cache.lazyloadCheckTimer = setTimeout(() => {
      this.iScroll.refresh();
    }, 200);
  },
  handleBlur() {
    // this.forceLazyLoadCheck();
  },
  render() {
    const { keyWord } = this.state;
    const searchDishItem = this.formatSearchDishItem(keyWord);
    return (
      <div className="search-part">
        <SearchHead
          placeholder={formatMessage(globalMessages.searchPlacehodler)}
          buttonKind={{
            text: formatMessage(buttonMessages.cancel),
            clickCallBack: evt => this.headButtonClickCallBack(evt),
          }}
          getKeyWord={this.getKeyWord}
          handleBlur={this.handleBlur}
          ref="searchhead"
        />
        <div className="search-content of default">
          {searchDishItem && searchDishItem.length === 0 ? (
            <div className="nosearchdata">
              <img src={noSearchImg} alt={formatMessage(globalMessages.noSearchResult)} className="nosearchdata-img" />
              <FormattedMessage {...globalMessages.noSearchData} />
            </div>
          ) : (
            <ul className="dish-list clearfix">{searchDishItem}</ul>
          )}
        </div>
      </div>
    );
  },
});
module.exports = SearchDish;



// WEBPACK FOOTER //
// ./src/component/dish-menu/search-dish.jsx